import {
  Dispatch,
  RefObject,
  SetStateAction,
  useCallback,
  useLayoutEffect,
} from "react";

type HighlightStyle = {
  left: number;
  width: number;
};

interface TabHighlightProps {
  containerRef: RefObject<HTMLDivElement>;
  activeButtonRef: RefObject<HTMLButtonElement>;
  setHighlightStyle: Dispatch<SetStateAction<HighlightStyle>>;
}

export function useTabHighlight({
  containerRef,
  activeButtonRef,
  setHighlightStyle,
}: TabHighlightProps) {
  const updateHighlight = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;

    if (activeButtonRef.current) {
      setHighlightStyle({
        left: activeButtonRef.current.offsetLeft + 1,
        width: activeButtonRef.current.offsetWidth - 2,
      });
    }
  }, [containerRef, activeButtonRef, setHighlightStyle]);

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    updateHighlight();

    const resizeObserver = new ResizeObserver(updateHighlight);
    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, [containerRef, updateHighlight]);
}
